var DialogStates;
(function (DialogStates) {
    DialogStates["login"] = "login";
    DialogStates["otp"] = "otp";
    DialogStates["signup"] = "signup";
    DialogStates["guestCheckout"] = "guestCheckout";
})(DialogStates || (DialogStates = {}));

export { DialogStates };
//# sourceMappingURL=web.interface.js.map
